<div id="wrapper">
    <div id="menu-wrapper">
        <div id="menu" class="container">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li><a routerLink="/kunst">Kunst & Cultuur</a></li>
                <li><a routerLink="/zorg">Zorg</a></li>
                <li class="current_page_item"><a routerLink="/cultuur">Onderwijs</a></li>
                <li><a routerLink="/contact">Contact</a></li>
            </ul>
        </div>
    </div>
    <div id="banner">
    </div>
    <div id="page" class="container">
    <div id="content">
        <p>Het onderwijs is volop in beweging en het verandert continu. Vooral in deze tijd. 
        Het onderwijs en de wijze van lesgeven verschuift van klassikaal naar onderwijs op afstand. We zien meer praktijkgericht en uitvoerend onderwijs ontstaan. En door kostenbesparingen moeten onderwijsinstellingen en studenten veel meer in een korte tijd. </p>
        <p>Al deze veranderingen vragen om flexibiliteit. Denk bijvoorbeeld aan een vakdocent op oproepbasis, in plaats van een vaste kracht voor de klas. Ook zien we steeds meer professionals die naast hun werk als acteur, technicus of ontwerper studenten lesgeven. Op deze manier brengen ze hun passie en talent voor het vak over op een jonge en nieuwe generatie, terwijl ze zelf nog met de ‘voeten in de modder’ staan. </p>
        <p>AC beweegt mee met deze veranderingen en ondersteunt onderwijsinstellingen met het aanpassen naar deze nieuwe tijd. Een aantal van onze medewerkers staan zelf voor de klas, of zijn onderdeel van het management, waardoor ze zich nog extra betrokken voelen met het onderwijs.</p>
        <div class="title">
            <h2>ONZE FOCUS</h2>
        </div>
        <p><b>Onderwijs (o.a.)</b></p>
        <ul style="list-style-type:disc;">
            <li>Multimedia en vormgeving</li>
            <li>Podium- en Evenemententechniek</li>
            <li>Filmacademie</li>
            <li>Filmacteurs</li>
            <li>Kleinkunstacademie</li>
            <li>Toneelschool</li>
            <li>AV onderwijs</li>
            <li>Dansacademie</li>
            <li>Muziekacademie</li>
            <li>VMBO, MBO, HBO en Universiteit</li>
        </ul>
    </div>
</div>
</div>
<div id="footer-wrapper">
    <div id="footer" class="container">
        <div id="box1">
            <h2>Contact</h2>
            <p>Auxilium Cu(ltu)ra BV, Vliet Noordzijde 49 2231 GP Rijnsburg</p>
            <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;info@auxiliumcultura.nl</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 - 53 43 89 00</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 – 22 50 70 90</p>
        </div>
    </div>
</div>
<div id="copyright-wrapper" class="container">
    <div id="copyright" class="container">
        <p><a routerLink="/copyright">Terms and Conditions</a></p>
    </div>
</div>